(() => {
  const setupSlider = (slider) => {
    if (slider.dataset.sliderReady === 'true') return;

    const track = slider.querySelector('[data-featured-products-track]');
    const previous = slider.querySelector('[data-featured-products-previous]');
    const next = slider.querySelector('[data-featured-products-next]');
    if (!track || !previous || !next) return;

    slider.dataset.sliderReady = 'true';

    const updateButtons = () => {
      const maximumScroll = track.scrollWidth - track.clientWidth;
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maximumScroll - 2;
    };

    const move = (direction) => {
      const card = track.querySelector('.featured-product-card');
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      track.scrollBy({ left: distance * direction, behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', updateButtons, { passive: true });
    new ResizeObserver(updateButtons).observe(track);
    updateButtons();
  };

  const setupAll = (root = document) => {
    root.querySelectorAll('[data-featured-products-slider]').forEach(setupSlider);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupAll());
  } else {
    setupAll();
  }

  document.addEventListener('shopify:section:load', (event) => setupAll(event.target));
})();
